import React, { useEffect, useState } from 'react';
import { Bell, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { registerPushForUser } from '@/lib/pushNotifications';

type Props = {
  email?: string | null;
  isMember?: boolean;
};

const CallNotificationPrompt: React.FC<Props> = ({ email, isMember }) => {
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!isMember || !email) return;
    if (!('Notification' in window)) return;
    if (Notification.permission === 'granted') return;
    setShow(true);
  }, [email, isMember]);

  const enable = async () => {
    if (!email) return;
    setBusy(true);
    try {
      await registerPushForUser(email);
      setShow(false);
    } finally {
      setBusy(false);
    }
  };

  const dismiss = () => {
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed left-3 right-3 bottom-4 z-[9999] rounded-2xl bg-gradient-to-r from-fuchsia-700 to-amber-500 p-4 text-white shadow-2xl">
      <div className="flex items-start gap-3">
        <Bell className="w-6 h-6 shrink-0 mt-1" />
        <div className="flex-1">
          <div className="font-bold text-base">Enable Call Notifications</div>
          <div className="text-sm opacity-95">
            Let family reach you for voice and video calls even when KinsCircle is closed.
          </div>
          <Button onClick={enable} disabled={busy} className="mt-3 bg-white text-fuchsia-800 hover:bg-white/90 rounded-full">
            {busy ? 'Enabling...' : 'Enable'}
          </Button>
        </div>
        <button onClick={dismiss} aria-label="Dismiss">
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default CallNotificationPrompt;
